<template>
  <div>
    <div class="processing-container-body">
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
type TProps = {
  message: string;
};
defineProps<TProps>();
</script>

<style lang="scss" scoped>
.processing-container-body {
  padding: 20px;
  background-color: $bgcolor-base;
  border-radius: 4px;
  border: 1px solid $bdcolor-base;
}
</style>
